<template>
  <div v-show="visible">
    <div
      class="modal"
      style="display: block; background: rgba(0, 0, 0, 0.4)"
    ></div>
    <div
      class="modal-dialog"
      style="position: fixed; left: 25%; top: 25%; z-index: 8888"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            v-if="x"
            type="button"
            class="close"
            @click="closeAlertBoxDlg()"
          >
            ×
          </button>
          <h4 class="modal-title" style="color: black">{{ btitle }}</h4>
        </div>
        <div class="modal-body" :class="{ 'dialog-scroll': scroll }">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dialogBox",

  data() {
    return {
      visible: true,
    }
  },

  props: {
    btitle: String,
    scroll: Boolean,
    x: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    closeAlertBoxDlg() {
      this.$emit("close")
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-scroll {
  min-height: 210px;
  max-height: 410px;
  overflow: auto;
}
</style>
 
